/*  eslint-disable no-console */
function noopResolve() {
  console.error('[promise]~noopResolve, have been called');
}

function noopRefject() {
  console.error('[promise]~noopRefject, have been called');
}

export function promiseWithResolver<T>() {
  let resolve: (value: T) => void = noopResolve;
  let reject: (reason: any) => void = noopRefject;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve, reject };
}
